<div [style]="{ '--size': size }" class="language-container">
  <mat-select [(ngModel)]="selectedLanguage">
    @if (searchBar) {
      <div class="select-input">
        <input (keydown)="$event.stopPropagation()" [(ngModel)]="filterQuery" autocomplete="off" matInput />
      </div>
    }
    @for (languageOption of filteredList; track languageOption.cc) {
      <mat-option [value]="languageOption">
        <div class="language-option">
          <div [style.background-image]="'url(\'../../../assets/images/flags/' + languageOption.cc + '.svg\')'" class="flag"></div>
          {{ getLabel(languageOption) }}
        </div>
      </mat-option>
    } @empty {
      <div class="select-no-data">No data found!</div>
    }
    <mat-select-trigger>
      <div [matTooltip]="getLabel(selectedLanguage)" class="flex-selector">
        <div [style.background-image]="'url(\'../../../assets/images/flags/' + selectedLanguage?.cc + '.svg\')'" class="flag"></div>
      </div>
    </mat-select-trigger>
  </mat-select>
</div>
